module.exports = __webpack_public_path__ + "media/images/ico-supply-0ddd1a68088d38eae53ec9a75fe65829.svg";